module.exports = __webpack_public_path__ + "static/scale-model-of-wisconsin-historical-museum-in-madison-wisconsin-70e6508d5b51f88bf3e096facb35d81a.png";